if (!customElements.get("custom-variant-options")) {
    customElements.define(
      "custom-variant-options",
      class CustomVariantOptions extends HTMLElement {
        constructor() {
          super();
          this.addEventListener("change", this.onVariantChange);
          this.addEventListener("keydown", this.onKeyDown);
        }
  
        whenLoaded = Promise.all([customElements.whenDefined("gallery-section")]);
  
        connectedCallback() {
          this.whenLoaded.then(() => {
            this.initialize();
          });
        }
  
        disconnectedCallback() {}
  
        initialize() {
          this.productInfoContainer = this.closest('.wt-product__info')
      
          this.addButton = this.productInfoContainer.querySelector('.js-add-to-cart.product-form__submit')
          this.selectedSpan = this.addButton.querySelector('.add-to-cart__selected')
          this.hasSizeVariant = this.selectedSpan.classList.contains('add-to-cart__selected--hidden')
          this.isComingSoon = this.dataset.isComingSoon === '';
          if(this.hasSizeVariant && !this.isComingSoon){
            this.addButton.setAttribute('disabled', 'true')
            this.selectedSpans = document.querySelectorAll('.add-to-cart__selected')
            this.selectSpans = document.querySelectorAll('.add-to-cart__select')
          }
          this.isFirstVariantChange = true;
          if (this.selectDefaultSize()) {
            this.onVariantChange();
            return;
          }
          this.updateOptions();
          this.updateMasterId();
          this.updateGallery();
          this.updateVariantStatuses();
        }

        selectDefaultSize() {
          if (this.isComingSoon) return false;

          const optionGroups = Array.from(
            this.querySelectorAll(".wt-product__option"),
          );
          const sizeOptionIndex = optionGroups.findIndex((option) =>
            option.classList.contains("wt-product__option--size"),
          );
          if (sizeOptionIndex === -1) return false;

          const sizeInputs = Array.from(
            optionGroups[sizeOptionIndex].querySelectorAll('input[type="radio"]'),
          );
          if (!sizeInputs.length) return false;

          const variants = this.getVariantData();
          const requestedVariantId = new URLSearchParams(window.location.search).get(
            "variant",
          );
          const requestedVariant = requestedVariantId
            ? variants.find(
                (variant) =>
                  String(variant.id) === requestedVariantId && variant.available,
              )
            : null;

          let sizeInput = requestedVariant
            ? sizeInputs.find(
                (input) =>
                  input.value === requestedVariant.options[sizeOptionIndex],
              )
            : null;

          if (!sizeInput) {
            sizeInput = sizeInputs.find((input) =>
              variants.some((variant) => {
                if (
                  !variant.available ||
                  variant.options[sizeOptionIndex] !== input.value
                ) {
                  return false;
                }

                return optionGroups.every((optionGroup, optionIndex) => {
                  if (optionIndex === sizeOptionIndex) return true;
                  const selectedInput = optionGroup.querySelector(
                    'input[type="radio"]:checked',
                  );
                  return (
                    !selectedInput ||
                    variant.options[optionIndex] === selectedInput.value
                  );
                });
              }),
            );
          }

          if (!sizeInput) return false;
          sizeInput.checked = true;
          return true;
        }
  
        onKeyDown(event) {
          if (event.key === "Enter" || event.keyCode === 13) {
            const input = event.target.querySelector("input");
            input.click();
            // this.onVariantChange();
          }
        }
  
        onVariantChange() {
            if(this.isFirstVariantChange && this.hasSizeVariant) {
                this.selectSpans.forEach(el => el.classList.remove('add-to-cart__select--visible'))
                this.selectedSpans.forEach(el => el.classList.remove('add-to-cart__selected--hidden'))
                this.addButton.classList.remove('product-form__submit--select')
                this.addButton.removeAttribute('disabled')
                this.isFirstVariantChange = false
            }

          const variantChangeStartEvent = new CustomEvent("variantChangeStart", {
            bubbles: true,
            composed: true,
          });
          this.dispatchEvent(variantChangeStartEvent);
          this.updateOptions();
          this.updateMasterId();
          this.updateGallery();
          this.toggleAddButton(true, "", false);
          //this.updatePickupAvailability();
          this.removeErrorMessage();
          this.updateVariantStatuses();
          this.updateInventoryLevel();
  
          if (!this.currentVariant) {
            this.toggleAddButton(true, "", true);
            this.setUnavailable();
          } else {
            this.updateMedia();
            this.lenOfVariantOptions =
              document.querySelectorAll("variant-options").length;
            if (this.lenOfVariantOptions === 1) {
              this.updateURL();
            }
            this.updateVariantInput();
            this.renderProductInfo();
            this.updateShareUrl();
          }
          const variantChangeEndEvent = new CustomEvent("variantChangeEnd", {
            bubbles: true,
            composed: true,
          });
          this.dispatchEvent(variantChangeEndEvent);
        }

        updateInventoryLevel() {
          console.log(this.getVariantInventoryData())
          console.log(this.currentVariant.id)
          const inventory = this.getVariantInventoryData().find(
            (variant) => variant.id == this.currentVariant.id,
          );
          const inventoryElement = this.productInfoContainer.querySelector('.wt-product__inventory')
          if (!inventoryElement || this.isComingSoon) return;
          if (inventory) {
            // if inventory.inventory_quantity < 5 show (LOW STOCK) 
            if(inventory.inventory_quantity < 5 && inventory.inventory_quantity > 0){
              inventoryElement.innerHTML = '(LOW STOCK)'
            } else {
              inventoryElement.innerHTML = "";
            }
          } else {
            inventoryElement.innerHTML = "(OUT OF STOCK)";
          }
        }
        
  
        updateGallery() {
          const mediaGallery = document.getElementById(
            `MediaGallery-${this.dataset.section}`,
          );
          
          let media_id = false;
          if (this.currentVariant && this.currentVariant.featured_media) {
            media_id = this.currentVariant.featured_media.id;
          }
          console.log(this.options)
          try{
            mediaGallery?.filterSlides(this.options, media_id, true);
          } catch (err){
            console.error(err)
          }
        }
  
        updateOptions() {
            // const addButton = document.querySelector('.js-add-to-cart.product-form__submit')
            // addButton.removeAttribute('disabled')

            // const selectSpan = addButton.querySelector('.add-to-cart__select')
            // const selectedSpan = addButton.querySelector('.add-to-cart__selected')

            // selectSpan.classList.remove('add-to-cart__selected--hidden')
            // selectedSpan.classList.add('add-to-cart__select--visible')


          const fieldsets = Array.from(
            this.querySelectorAll(".wt-product__option"),
          );
          this.options = fieldsets.map((fieldset) => {
            return Array.from(fieldset.querySelectorAll("input")).find(
              (radio) => radio.checked,
            )?.value || '';
          });
  
          fieldsets.forEach((fieldset, index) => {
            const selectedOption = this.options[index] || '';
            fieldset.querySelector(
              ".wt-product__option__title .value",
            ).innerHTML = selectedOption;
            const dropdown = fieldset.querySelector(
              ".wt-product__option__dropdown span",
            );
            if (dropdown) dropdown.innerHTML = selectedOption;
          });
        }
  
        updateMasterId() {
          this.currentVariant = this.getVariantData()?.find((variant) => {
            return !variant.options
              .map((option, index) => {
                return this.options[index] === option;
              })
              .includes(false);
          });
        }
  
        updateMedia() {
          if (!this.currentVariant) return;
          this.setAttribute("data-variant-id", this.currentVariant?.id);
          if (!this.currentVariant.featured_media) return;
          this.setAttribute(
            "data-featured-image",
            this.currentVariant?.featured_media?.preview_image?.src,
          );
          this.setAttribute(
            "data-featured-image-id",
            this.currentVariant?.featured_media?.id,
          );
  
          const modalContent = document.querySelector(
            `#ProductModal-${this.dataset.section} .product-media-modal__content`,
          );
          if (!modalContent) return;
          const newMediaModal = modalContent.querySelector(
            `[data-media-id="${this.currentVariant.featured_media.id}"]`,
          );
          modalContent.prepend(newMediaModal);
        }
  
        updateURL() {
          if (!this.currentVariant || this.dataset.updateUrl === "false") return;
          window.history.replaceState(
            {},
            "",
            `${this.dataset.url}?variant=${this.currentVariant.id}`,
          );
        }
  
        updateShareUrl() {
          const shareButton = document.getElementById(
            `Share-${this.dataset.section}`,
          );
          if (!shareButton || !shareButton.updateUrl) return;
          shareButton.updateUrl(
            `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`,
          );
        }
  
        updateVariantInput() {
          const productForms = document.querySelectorAll(
            `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
          );
          productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event("change", { bubbles: true }));
          });
        }
  
        updateVariantStatuses() {
          // const selectedOptionOneVariants = this.variantData.filter(
          //   (variant) => this.querySelector(':checked').value === variant.option1
          //   );
          const selectedOptionOneVariants = this.variantData?.filter(
            (variant) => variant.available === true,
          );
          const inputWrappers = [
            ...this.querySelectorAll(".product-form__input"),
          ];
          inputWrappers.forEach((option, index) => {
            if (index === 0 && this.currentVariant?.options.length > 1) return;
            const optionInputs = [
              ...option.querySelectorAll('input[type="radio"], option'),
            ];
            const previousOptionSelected =
            inputWrappers[index - 1]?.querySelector(":checked")?.value;
            const availableOptionInputsValue = selectedOptionOneVariants
            .filter(
              (variant) =>
              variant.available &&
              variant[`option${index}`] === previousOptionSelected,
            )
            .map((variantOption) => variantOption[`option${index + 1}`]);
            console.log(selectedOptionOneVariants)
            this.setInputAvailability(optionInputs, availableOptionInputsValue);            
          });
        }
  
        setInputAvailability(listOfOptions, listOfAvailableOptions) {          
          listOfOptions.forEach((input) => {
            if (this.isComingSoon) {
              input.classList.add("disabled");
            } else if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
              input.classList.remove("disabled");
            } else {
              input.classList.add("disabled");
            }
          });
        }
  
        updatePickupAvailability() {
          const pickUpAvailability = document.querySelector(
            "pickup-availability",
          );
          if (!pickUpAvailability) return;
  
          if (this.currentVariant && this.currentVariant.available) {
            pickUpAvailability.fetchAvailability(this.currentVariant.id);
          } else {
            pickUpAvailability.removeAttribute("available");
            pickUpAvailability.innerHTML = "";
          }
        }
  
        removeErrorMessage() {
          const section = this.closest("section");
          if (!section) return;
  
          const productForm = section.querySelector("product-form");
          if (productForm) {
            productForm?.handleErrorMessage();
          }
        }
  
        renderProductInfo() {
          const requestedVariantId = this.currentVariant.id;
          const sectionId = this.dataset.originalSection
            ? this.dataset.originalSection
            : this.dataset.section;
  
          fetch(
            `${this.dataset.url}?variant=${requestedVariantId}
          `,
          )
            .then((response) => response.text())
            .then((responseText) => {
              // prevent unnecessary ui changes from abandoned selections
              if (this.currentVariant.id !== requestedVariantId) return;
  
              const html = new DOMParser().parseFromString(
                responseText,
                "text/html",
              );
              const destination = document.getElementById(
                `price-${this.dataset.section}`,
              );
              const source = html.getElementById(
                `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
              );
              const skuSource = html.getElementById(
                `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
              );
              const skuDestination = document.getElementById(
                `Sku-${this.dataset.section}`,
              );
              const inventorySource = html.getElementById(
                `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
              );
              const inventoryDestination = document.getElementById(
                `Inventory-${this.dataset.section}`,
              );
  
              if (source && destination) destination.innerHTML = source.innerHTML;
              if (inventorySource && inventoryDestination)
                inventoryDestination.innerHTML = inventorySource.innerHTML;
              if (skuSource && skuDestination) {
                skuDestination.innerHTML = skuSource.innerHTML;
                skuDestination.classList.toggle(
                  "visibility-hidden",
                  skuSource.classList.contains("visibility-hidden"),
                );
              }
  
              const price = document.getElementById(
                `price-${this.dataset.section}`,
              );
  
              if (price) price.classList.remove("visibility-hidden");
  
              if (inventoryDestination)
                inventoryDestination.classList.toggle(
                  "visibility-hidden",
                  inventorySource.innerText === "",
                );
  
              const addButtonUpdated = html.getElementById(
                `ProductSubmitButton-${sectionId}`,
              );

              if(!this.isComingSoon) this.toggleAddButton(
                addButtonUpdated
                  ? addButtonUpdated.hasAttribute("disabled")
                  : true,
                window.variantStrings.soldOut,
              );
            });
        }
  
        toggleAddButton(disable = true, text, modifyClass = true) {
          const productForm = document.getElementById(
            `product-form-${this.dataset.section}`,
          );
          if (!productForm) return;
          const addButton = productForm.querySelector('[name="add"]');
          const addButtonText = productForm.querySelector('[name="add"] > span');
          if (!addButton) return;
  
          if (disable) {
            addButton.setAttribute("disabled", "disabled");
            if (text) addButtonText.textContent = text;
          } else {
            addButton.removeAttribute("disabled");
            addButtonText.textContent = window.variantStrings.addToCart;
          }
  
          if (!modifyClass) return;
        }
  
        setUnavailable() {
          const button = document.getElementById(
            `product-form-${this.dataset.section}`,
          );
          const addButton = button.querySelector('[name="add"]');
          const addButtonText = button.querySelector('[name="add"] > span');
          const price = document.getElementById(`price-${this.dataset.section}`);
          const inventory = document.getElementById(
            `Inventory-${this.dataset.section}`,
          );
          const sku = document.getElementById(`Sku-${this.dataset.section}`);
  
          if (!addButton) return;
          addButtonText.textContent = window.variantStrings.unavailable;
          if (price) price.classList.add("visibility-hidden");
          if (inventory) inventory.classList.add("visibility-hidden");
          if (sku) sku.classList.add("visibility-hidden");
        }
  
        getVariantData() {
          this.variantData =
            this.variantData ||
            JSON.parse(
              this.querySelector('#variantData[type="application/json"]').textContent,
            );
          return this.variantData;
        }

        getVariantInventoryData() {
          this.variantInventoryData =
            this.variantInventoryData ||
            JSON.parse(
              this.querySelector('#variantInventoryData[type="application/json"]').textContent,
            );
          return this.variantInventoryData;
        }
      },
    );
  }
  // customElements.define('variant-options', VariantOptions);
  
